'use client';

import {useEffect} from 'react';

export const IntroHeightMeasurer = () => {
  useEffect(() => {
    const element = document.getElementById('career_intro');
    if (!element) {
      return;
    }
    const cleanupCallbacks: Array<VoidFunction> = [];

    const main = document.getElementsByTagName('main').item(0);
    const footer = document.getElementsByTagName('footer').item(0);

    if (main && window.ResizeObserver) {
      // замеряем высоту интро чтобы сдвигать контент ниже него
      const resizeObserver = new ResizeObserver(([entry]) => {
        const height = entry.contentRect.height;
        main.style.setProperty('--measured-intro-height', `${height}px`);
      });
      resizeObserver.observe(element);
      cleanupCallbacks.push(() => resizeObserver.disconnect());
    }

    if (footer && window.IntersectionObserver) {
      // прячем интро когда футер на экране, иначе кусочек интро можно увидеть под ним при оверскролле
      const intersectionObserver = new IntersectionObserver(
        ([entry]) => {
          element.style.opacity = `${entry.isIntersecting ? 0 : 1}`;
        },
        {threshold: 0.1},
      );
      intersectionObserver.observe(footer);

      cleanupCallbacks.push(() => intersectionObserver.disconnect());
    }

    return () => {
      cleanupCallbacks.forEach((cb) => cb());
    };
  }, []);

  return null;
};
